export default "__VITE_ASSET__BryKGaqX__"